import { testimonialsData } from '../../../mocks/testimonials';

const TestimonialsSection = () => {
  return (
    <section className="py-24 bg-neutral-50">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-secondary/10 rounded-full mb-6">
            <span className="text-secondary font-semibold text-sm">Müşteri Yorumları</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-primary mb-6 font-heading">
            Müşterilerimiz Ne Diyor?
          </h2>
          <p className="text-neutral-600 text-lg max-w-3xl mx-auto">
            2. el bilgisayar alım satım ve bilgisayar tamiri hizmetlerimizden yararlanan müşterilerimizin deneyimleri
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonialsData.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className={`bg-white rounded-xl p-8 shadow-card hover:shadow-card-hover transition-all duration-300 ${
                index % 3 === 1 ? 'lg:mt-8' : ''
              }`}
            >
              {/* Rating */}
              <div className="flex items-center space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>

              {/* Comment */}
              <p className="text-neutral-700 text-base leading-relaxed mb-6 italic">
                "{testimonial.comment}"
              </p>

              {/* User Info */}
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 flex items-center justify-center bg-accent/10 rounded-full text-accent font-bold">
                  {testimonial.avatar}
                </div>
                <div>
                  <p className="font-semibold text-primary">{testimonial.name}</p>
                  <p className="text-sm text-neutral-500">{testimonial.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;